export * from './initializers/keycloak-initializer.function';
